import React, { Component } from 'react';
import {
  apiGetMembers,
  apiGetPostalAddressOnly,
  apiSendCodeByEmail,
  apiUpdateAddress,
  apiUpdateEmail,
  apiUpdatePhone,
  apiCreateBeneficiary,
  apiDeleteBeneficiary
} from '../../Api/Profile/Profile';
import { connect } from 'react-redux';
import {
  ProfileScreen1Template,
  ProfileScreen2Template,
  AddBeneficiaireStep1Template,
  AddBeneficiaireStep2Template,
  AddBeneficiaireStep3Template,
  AddBeneficiaireStep4Template,
  ProfileTemplateScreen2Beneficiaire
} from '../../Templates';
import { serilizeGetMembers } from '../../Api/Profile/serilizeProfile';
import {
  FILE_SIZE_NOT_VALID,
  FILE_TYPE_NOT_VALID,
  validateSize,
  validateType
} from '../../Api/Profile/errorMessage';
import { isNumber } from '../../Validation';
import moment from 'moment';
import DocumentsService from '../../Services/DocumentsService';

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadAdressErrorMessage: '',
      isUploadAddressValid: true,
      showDropDown: false,
      addressDetails: null,
      optionAdressData: [],
      data: {
        name: 'Eva',
        birthDate: '05/03/1997',
        tel: '06 00 1',
        lastName: 'ROBIN',
        mail: 'test@test.com',
        adresse: '12 rue',
        completeAdresse: '12 rue',
        accountOwner: 'Eva  ROBIN',
        iban: 'FRPP XXXX XXXX XXXX XXXX XXXX XXX',
        bankName: 'Caisse d’Epargne',
        bic: 'CEPAXXXXXXXX',
        remboursement: true,
        prelevement: false,
        cp: '40047',
        ville: 'paris',
        title: 'MME',
        numeroSecuriteSociale: '265097512131545',
        rattachement: '0356153',
        typeBeneficiaire: 'Enfant',
        repaymentIban: '',
        repaymentAccountOwner: '',
        repaymentBic: ''
      },
      oldMail: '',
      editBank: false,
      showDeleteBeneficiaryCompleted: false,
      showDeleteBeneficiaryMessage:
        'Une demande de suppression du béneficiaire a été envoyée.',
      oldBankdata: {
        accountOwner: 'Eva  ROBIN',
        iban: 'FRPP XXXX XXXX XXXX XXXX XXXX XXX',
        bankName: 'Caisse d’Epargne',
        bic: 'CEPAXXXXXXXX',
        remboursement: true,
        prelevement: false
      },
      bankingInformation: {},
      editAdress: false,
      repaymentBankAccounts: {},
      manuelAddressEdit: false,
      oldAdress: {
        adresse: '',
        cp: '',
        ville: ''
      },
      editTel: false,
      oldTel: '',
      benificiaireList: [],
      step: 'PICK_BENEFICIAIRE',
      beneficiaireType: '',
      beneficiaireDataFomulaire: [
        {
          civilite: '',
          type: '',
          nom: '',
          prenom: '',
          birthDate: '',
          numSecurity: '',
          organism: '',
          dateEffet: '',
          realTimeValidation: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false
          ],
          validation: [true, true, true, true, true, true, true, true],
          errorMessage: ''
        }
      ],
      outilDeValidation: 'email',
      verificationCode: '',
      files: [],
      editMail: false,
      showConfirmationModal: false,
      code: '',
      verificationSteps: 1,
      confirmed: false,
      contracts: [],
      message: '',
      ServerErrorMessage: ''
    };
    this.debouncedOnChange = this.debounce(this.handleInputChange, 500);
  }

  handleInputChange = async (event) => {
    const res = await apiGetPostalAddressOnly(this.state.data.adresse);
    if (res.status == 200) {
      this.setState({
        optionAdressData: res.data,
        showDropDown: true
      });
    }
  };

  debounce = (func, delay) => {
    let inDebounce;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => func.apply(context, args), delay);
    };
  };

  getProfile = async () => {
    try {
      const res = await apiGetMembers(this.props.user.memberId);
      try {
        const localContenSquareData = JSON.parse(
          localStorage.getItem('ContenSquareData')
        );

        if (localContenSquareData) {
          localContenSquareData.product_name = res?.contracts[0]?.name;
          localStorage.setItem(
            'ContenSquareData',
            JSON.stringify(localContenSquareData)
          );
          window.dataLayer.push({
            ...localContenSquareData,
            funnel_step: location.pathname
          });
        } else {
          localStorage.setItem(
            'ContenSquareData',
            JSON.stringify({
              page_type: 'Home',
              env_id: 'monespaceassure SPVIE',
              funnel_step: 'main',
              product_name: res?.contracts[0]?.name
            })
          );
        }
      } catch (error) {
        console.log('error');
      }
      this.setState({
        benificiaireList: serilizeGetMembers(res, this.props.user.memberType),
        contracts: res.contracts,
        bankingInformation: res?.bankingInformation,
        repaymentBankAccounts: res?.repaymentBankAccounts
      });

      const action = {
        type: 'SET_PROFILE',
        value: {
          profile: serilizeGetMembers(res, this.props.user.memberType)
        }
      };
      this.props.dispatch(action);
    } catch (err) {
      this.setState({
        benificiaireList: []
      });
    }
  };

  componentDidMount() {
    this.getProfile();
  }

  setShowDeleteBeneficiaryCompleted = (value) => {
    this.setState({
      showDeleteBeneficiaryCompleted: value
    });
    this.props.history.push({
      pathname: '/profile',
      search: `?category=success`
    });
  };

  isAddressValid = () => {
    const size = this.state.files[0].size;
    const type = this.state.files[0].type;
    const isValidType = validateType(type);
    const isValidSize = validateSize(size);
    return { isValidSize, isValidType };
  };

  showModal = async () => {
    const validation = this.state.editAdress
      ? this.isAddressValid()
      : { isValidSize: false, isValidType: false };
    if (
      this.state.editAdress &&
      (!validation.isValidSize || !validation.isValidType)
    ) {
      if (!validation.validateType) {
        this.setState({
          isUploadAddressValid: false,
          uploadAdressErrorMessage: FILE_TYPE_NOT_VALID
        });
      }
      if (!validation.isValidSize) {
        this.setState({
          isUploadAddressValid: false,
          uploadAdressErrorMessage: FILE_SIZE_NOT_VALID
        });
      }
      return;
    }
    await apiSendCodeByEmail(this.props.user.memberId);
    this.setState({
      showConfirmationModal: true,
      isUploadAddressValid: true,
      uploadAdressErrorMessage: ''
    });
  };

  onHide = () => {
    this.setState({
      showConfirmationModal: false,
      verificationSteps: 1
    });
  };

  onChangeCode = (value) => {
    this.setState({
      code: value
    });
  };

  onConfirmCode = async () => {
    let res = null;
    if (this.state.editTel) {
      res = await apiUpdatePhone(
        this.props.user.memberId,
        this.state.code,
        this.state.data.tel
      );
    }
    if (this.state.editMail) {
      res = await apiUpdateEmail(
        this.props.user.memberId,
        this.state.code,
        this.state.data.mail
      );
    }
    if (this.state.editAdress) {
      const body = new FormData();
      body.append('Address', this.state.data.adresse);
      body.append('City', this.state.data.ville);
      body.append('PostalCode', this.state.data.cp);
      body.append('Country', 'France');
      body.append('ProofOfAddress', this.state.files[0]);

      res = await apiUpdateAddress(
        this.props.user.memberId,
        this.state.code,
        body
      );
    }
    if (res && res.status === 200) {
      this.setState({
        verificationSteps: 2,
        editTel: false,
        editMail: false,
        editAdress: false
      });
    }
  };

  handleDeleteBeneficiary = async () => {
    const cloneData = JSON.parse(JSON.stringify(this.state.data));
    const body = new FormData();
    const benefRelatedIndex = ['Child', 'Spouse', 'Ascending'];
    body.append('FirstName', cloneData.name);
    body.append('LastName', cloneData.lastName);
    body.append('BirthDate', moment(cloneData.birthDate).format('DD/MM/YYYY'));
    body.append('SocialSecurityNumber', cloneData.numeroSecuriteSociale);
    body.append('Related', benefRelatedIndex.indexOf(cloneData.related));

    const res = await apiDeleteBeneficiary(this.state.contracts[0].id, body);
    if (res.status === 200) {
      this.setState({
        showDeleteBeneficiaryMessage:
          'Une demande de suppression du béneficiaire a été envoyée.'
      });
      this.setShowDeleteBeneficiaryCompleted(true);
    } else if (res.status === 400) {
      this.setState({
        showDeleteBeneficiaryMessage:
          'Une demande de suppression du béneficiaire a déjà été envoyée.'
      });
      this.setShowDeleteBeneficiaryCompleted(true);
    } else {
      showDeleteBeneficiaryMessage: "Une erreure s'est produite lors de l'envoi de la demande.";
    }
  };

  handelEditMail = (value) => {
    if (!this.state.editTel && !this.state.editAdress) {
      this.setState({
        editMail: value,
        oldMail: this.state.data.mail
      });
      if (!value) {
        this.setState({
          data: { ...this.state.data, mail: this.state.oldMail }
        });
      }
    }
  };

  onIconClick = () => {
    this.setState({
      step: 'PICK_BENEFICIAIRE'
    });
    this.props.history.push({
      pathname: '/profile',
      search: ``
    });
  };

  selectFile = (e) => {
    this.setState({ files: e });
  };

  onChangeVerificationCode = (value) => {
    this.setState({
      verificationCode: value
    });
  };

  onSelectOutilDeValidation = (value) => {
    this.setState({
      outilDeValidation: value
    });
  };

  handelSelectedProfile = (value, index) => {
    if (index === 0) {
      this.setState({
        data: {
          ...value,
          iban: this.state?.bankingInformation?.iban,
          accountOwner: this.state?.bankingInformation?.accountOwnerName,
          bic: this.state?.bankingInformation?.bic,
          repaymentIban: this?.state?.repaymentBankAccounts?.length
            ? this?.state?.repaymentBankAccounts[0]?.iban
            : '',
          repaymentAccountOwner: this?.state?.repaymentBankAccounts?.length
            ? this?.state?.repaymentBankAccounts[0]?.accountOwnerName
            : '',
          repaymentBic: this?.state?.repaymentBankAccounts?.length
            ? this?.state?.repaymentBankAccounts[0]?.bic
            : ''
        },
        step: 'EDIT_PROFILE',
        addressDetails: null
      });
      this.props.history.push({
        pathname: '/profile',
        search: `?category=principal`
      });
    } else {
      this.setState({
        data: value,
        step: 'EDIT_PROFILE_BENEFICIAIRE',
        addressDetails: null
      });
      this.props.history.push({
        pathname: '/profile',
        search: `?category=beneficiaire${index}`
      });
    }
  };

  onChange = async (value, key) => {
    const aux = { ...this.state.data };
    if (key === 'completeAdresse') {
      aux[key] = value;
      this.setState({
        data: { ...aux }
      });
      const res = await apiGetPostalAddressOnly(value);
      if (res.status == 200) {
        this.setState({
          optionAdressData: res.data,
          showDropDown: true
        });
      } else {
        this.setState({
          optionAdressData: []
        });
      }
      return;
    }
    if (key !== 'tel') {
      aux[key] = value;
      this.setState({ data: aux });
    } else if (value.length <= 15) {
      const onlyNumber = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g);
      aux[key] = onlyNumber;
      this.setState({ data: aux });
    }
  };

  onChangeBankType = (key) => {
    const aux = { ...this.state.data };
    if (key === 'remboursement') {
      aux.prelevement = false;
    } else {
      aux.remboursement = false;
    }
    aux[key] = true;
    this.setState({ data: aux });
  };

  cancelEditBank = () => {
    this.setState({
      data: { ...this.state.data, ...this.state.oldBankdata },
      editBank: false
    });
  };

  handelEditAdresse = (value) => {
    if (!this.state.editTel && !this.state.editMail) {
      this.setState({
        editAdress: value,
        oldAdress: {
          adresse: this.state.data.adresse,
          cp: this.state.data.cp,
          ville: this.state.data.ville
        }
      });
    }
    if (!value) {
      if (window.innerWidth <= 768) {
        this.setState({
          data: {
            ...this.state.data,
            ...this.state.oldAdress,
            tel: this.state.oldTel,
            mail: this.state.oldMail
          },
          manuelAddressEdit: false,
          editTel: false,
          editMail: false
        });
      } else {
        this.setState({
          data: { ...this.state.data, ...this.state.oldAdress },
          manuelAddressEdit: false
        });
      }
    }
  };

  handelEditTel = (value) => {
    if (!this.state.editMail && !this.state.editAdress) {
      this.setState({
        editTel: value,
        oldTel: this.state.data.tel
      });
      if (!value) {
        this.setState({
          data: { ...this.state.data, tel: this.state.oldTel }
        });
      }
    }
  };

  handelManuelAddressEdit = (value) => {
    this.setState({ manuelAddressEdit: !this.state.manuelAddressEdit });
  };

  addParamsInHistory = () => {
    this.props.history.push({
      pathname: '/profile',
      search: `?category=supprimer-beneficiaire`
    });
  };

  handelEditBank = async (value) => {
    const bankCategory = await DocumentsService.getParentCategoryByName(
      'Banque'
    );
    this.props.history.push('/documents/send', {
      goToCategory: bankCategory
    });
  };

  navigationSteps = (value) => {
    this.setState({ step: value });
    this.props.history.push({
      pathname: '/profile',
      search: `?category=ajout-beneficiaire&subcategory=contrat`
    });
  };

  onSelectTypeBeneficiaire = (value) => {
    this.setState({
      step: 'ADD_BENEFICIAIRE_STEP2',
      beneficiaireType: value
    });
    this.props.history.push({
      pathname: '/profile',
      search: `?category=ajout-beneficiaire&subcategory=informations`
    });
  };

  onChangeBeneficiaireData = (value, key, index, indexValidtion) => {
    const aux = [...this.state.beneficiaireDataFomulaire];
    if (['nom', 'prenom', 'numSecurity', 'organism'].includes(key)) {
      if (value.trim().length > 0) {
        aux[index].realTimeValidation[indexValidtion] = true;
      } else {
        aux[index].realTimeValidation[indexValidtion] = false;
      }
    } else {
      aux[index].realTimeValidation[indexValidtion] = true;
    }
    switch (key) {
      case 'numSecurity':
        if ((isNumber(value) && value.length <= 15) || !value) {
          aux[index][key] = value;
        }
        break;
      case 'organism':
        if ((isNumber(value) && value.length <= 9) || !value) {
          aux[index][key] = value;
        }
        break;
      default:
        aux[index][key] = value;
    }
    this.setState({ beneficiaireDataFomulaire: aux });
  };

  CloseModal = () => {
    this.setState({
      showConfirmationModal: false
    });
  };

  addOtherBenef = () => {
    const aux = [...this.state.beneficiaireDataFomulaire];
    aux.push({
      civilite: '',
      type: '',
      nom: '',
      prenom: '',
      birthDate: '',
      numSecurity: '',
      organism: '',
      dateEffet: '',
      realTimeValidation: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ],
      validation: [true, true, true, true, true, true, true, true],
      errorMessage: ''
    });
    this.setState({ beneficiaireDataFomulaire: aux });
  };

  onValidStep = () => {
    console.log('pop');
    const aux = [...this.state.beneficiaireDataFomulaire];
    let valid = true;
    for (let i = 0; i < aux.length; i++) {
      if (
        aux[i].realTimeValidation.includes(false) ||
        this.state.files.length == 0
      ) {
        valid = false;
        aux[i].errorMessage =
          'Merci de bien vouloir compléter tous les champs.';
      } else {
        aux[i].errorMessage = '';
      }
      aux[i].validation = aux[i].realTimeValidation;
    }
    if (valid) {
      //this.navigationSteps('ADD_BENEFICIAIRE_STEP3');
    }
    this.setState(
      {
        beneficiaireDataFomulaire: aux
      },
      () => this.AddBenefSendData(this.state.beneficiaireDataFomulaire[0])
    );
  };

  onCancelClick = () => {
    this.setState({
      step: 'ADD_BENEFICIAIRE_STEP1'
    });
  };

  AddBenefSendData = async (benef) => {
    const body = new FormData();
    console.log(benef);
    body.append('Civility', benef.civilite);
    body.append('FirstName', benef.prenom);
    body.append('LastName', benef.nom);
    body.append('Related', 1);
    body.append(
      'BirthDate',
      benef.dateEffet
        ? moment(benef.birthDate.toDateString()).format('DD/MM/YYYY')
        : null
    );
    body.append('SocialSecurityNumber', benef.numSecurity);
    body.append('AffiliatedOrganization', benef.organism);
    body.append(
      'AffiliationDate',
      benef.dateEffet
        ? moment(benef.dateEffet.toDateString()).format('DD/MM/YYYY')
        : null
    );
    body.append('Files', this.state.files[0]);
    body.append('MailPhoneFax.EmailAddress', 'email');
    body.append('MailPhoneFax.Phone', 'phone');
    body.append('MailPhoneFax.HomePhoneNumber', 'phone');
    body.append('MailPhoneFax.Fax', 'fax');
    const res = await apiCreateBeneficiary(
      this.state.beneficiaireType.id,
      body
    );
    if (res.status === 200) {
      this.setState({
        message: res.message,
        showConfirmationModal: true,
        ServerErrorMessage: ''
      });
    } else {
      var ErrorMessage = '';
      res.errors.map((el) => {
        ErrorMessage += el + '\n';
      });
      console.log(ErrorMessage);
    }
  };

  autoCompleteOptionClicked = (element) => {
    const aux = { ...this.state.data };
    this.setState({
      data: {
        ...aux,
        adresse: element.address,
        ville: element.city,
        cp: element.postCode,
        completeAdresse: element.label
      },
      addressDetails: element
    });
    this.setState({
      showDropDown: false
    });
  };

  autoCompleteClickAway = () => {
    this.setState({
      showDropDown: false
    });
  };

  render() {
    switch (this.state.step) {
      case 'PICK_BENEFICIAIRE':
        return <ProfileScreen1Template {...this} {...this.state} />;
      case 'EDIT_PROFILE':
        return <ProfileScreen2Template {...this} {...this.state} />;
      case 'EDIT_PROFILE_BENEFICIAIRE':
        return <ProfileTemplateScreen2Beneficiaire {...this} {...this.state} />;
      case 'ADD_BENEFICIAIRE_STEP1':
        return <AddBeneficiaireStep1Template {...this} {...this.state} />;
      case 'ADD_BENEFICIAIRE_STEP2':
        return <AddBeneficiaireStep2Template {...this} {...this.state} />;
      case 'ADD_BENEFICIAIRE_STEP3':
        return <AddBeneficiaireStep3Template {...this} {...this.state} />;
      case 'ADD_BENEFICIAIRE_STEP4':
        return <AddBeneficiaireStep4Template {...this} {...this.state} />;
      default:
        return null;
    }
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: (action) => {
      dispatch(action);
    }
  };
};
const mapStateToProps = (state) => ({
  user: state.auth.user
});
export default connect(mapStateToProps, mapDispatchToProps)(Profile);
